import { graphql, HttpResponse } from 'msw'
import { type EnrollmentMultiSuitabilityData, type EnrollmentMultiSuitabilitySubmitOutput } from '../../../../models'

export const getEnrollmentMultiSuitabilityDataMock: EnrollmentMultiSuitabilityData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/bd-shareholder',
  enrollmentData: {
    progress: 0.5,
    isBrokerDealer: true,
    isDirectorPolicyMakerOfCompany: true,
    directorPolicyMakerOfCompany: 'TSLA',
    investmentProfile: {
      isPoliticallyExposedPerson: true,
      affiliatedPoliticalOrganizations: ['TSLA'],
      hasPoliticallyExposedImmediateFamilyMembers: true,
      politicallyExposedImmediateFamilyMembers: ['TSLA'],
    },
  },
}

export const submitEnrollmentMultiSuitabilityDataMock: EnrollmentMultiSuitabilitySubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/verify-identity',
  enrollmentData: {
    progress: 0.5,
    isBrokerDealer: true,
    isDirectorPolicyMakerOfCompany: true,
    directorPolicyMakerOfCompany: 'TSLA',
    investmentProfile: {
      isPoliticallyExposedPerson: true,
      affiliatedPoliticalOrganizations: ['TSLA'],
      hasPoliticallyExposedImmediateFamilyMembers: true,
      politicallyExposedImmediateFamilyMembers: ['TSLA'],
    },
  },
}

export const mockGetEnrollmentMultiSuitabilityData = graphql.mutation('getEnrollmentMultiSuitabilityData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiSuitabilityDataMock } })
})

export const mockSubmitEnrollmentMultiSuitabilityData = graphql.mutation('submitEnrollmentMultiSuitabilityData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiSuitabilityDataMock } })
})

export const mockEnrollmentMultiSuitability = [
  mockGetEnrollmentMultiSuitabilityData,
  mockSubmitEnrollmentMultiSuitabilityData,
]
